import Icon from '../components/Icon.vue'

Icon.register({
  language: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M152.1 236.2l10.9 37.5h-38.1l11.1-37.5c3.5-12.1 7.8-33.2 7.8-33.2h0.5s4.3 21.1 7.8 33.2zM616 96c13.3 0 24 10.7 24 24v272c0 13.3-10.7 24-24 24h-280v-320h280zM592 216v-16c0-6.6-5.4-12-12-12h-64v-16c0-6.6-5.4-12-12-12h-16c-6.6 0-12 5.4-12 12v16h-64c-6.6 0-12 5.4-12 12v16c0 6.6 5.4 12 12 12h114.3c-6.2 14.3-16.5 29-30 43.2-6.6-6.9-12.4-13.9-17.4-20.9-3.6-5.1-10.6-6.6-16-3.4l-7.3 4.3-6.5 3.9c-5.9 3.5-7.7 11.4-3.7 17.1 6.1 8.7 13.1 17.3 21 25.7-8.1 6.3-16.8 12.3-26.1 18-5.6 3.4-7.4 10.6-4.2 16.2l7.9 13.9c3.4 5.9 10.9 7.8 16.7 4.3 12.7-7.8 24.5-16.2 35.4-24.9 10.9 8.8 22.8 17.1 35.4 24.9 5.8 3.5 13.3 1.6 16.7-4.3l7.9-13.9c3.2-5.7 1.4-12.8-4.1-16.2-9-5.5-17.7-11.6-26.1-18 21-22.5 35.8-46.3 42.7-69.9h11.4c6.6 0 12-5.4 12-12zM0 120c0-13.3 10.7-24 24-24h280v320h-280c-13.3 0-24-10.7-24-24v-272zM58.9 336.1c-2.6 7.8 3.2 15.9 11.4 15.9h22.9c5.3 0 10-3.6 11.5-8.7l9.1-31.8h60.2l9.4 31.9c1.4 4.7 6.6 8.6 11.5 8.6h22.9c8.3 0 14-8.1 11.4-15.9l-57.5-169.1c-1.7-4.8-6.3-8.1-11.4-8.1h-32.5c-5.2 0-9.7 3.2-11.4 8.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/language.js
// module id = 1504
// module chunks = 0